module.exports = __webpack_public_path__ + "media/honey-icons/icon-signal-3bar-16ccad32.svg";